// Каркас меты по UX-вайрфрейму (docs/ux-wireframe-meta.html):
// карта — топбар (профиль · мастерская · настройки) + нижний навбар из 4 вкладок;
// остальные экраны — саб-шапка с «назад». Плееры уровней шелл не используют.

import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '@/auth/authStore';
import { avatarById } from '@/meta/avatars';
import { usePrefs } from '@/meta/prefsStore';

export function AvatarFace({ avatarId, large }: { avatarId: string; large?: boolean }) {
  const a = avatarById(avatarId);
  return (
    <span
      className={large ? 'avatar-face lg' : 'avatar-face'}
      style={{ background: a.color }}
      role="img"
      aria-label={`Портрет: ${a.name}`}
    >
      {a.glyph}
    </span>
  );
}

/** Имя игрока для шапки: залогинен — displayName, гость — локальный ник. */
export function usePlayerName(): string {
  const auth = useAuth();
  const prefs = usePrefs();
  return auth.status === 'authed' && auth.me ? auth.me.displayName : prefs.guestName;
}

export function MetaTopBar() {
  const prefs = usePrefs();
  const name = usePlayerName();
  return (
    <header className="meta-topbar" data-testid="meta-topbar">
      <Link to="/profile" className="profile-chip" data-testid="topbar-profile">
        <AvatarFace avatarId={prefs.avatarId} />
        <span>{name}</span>
      </Link>
      <div className="meta-topbar-right">
        <Link to="/workshop" className="btn btn-ico" aria-label="Мастерская" title="Мастерская" data-testid="topbar-workshop">
          <img src="/assets/meta/icon-workshop.png" alt="" />
        </Link>
        <Link to="/settings" className="btn btn-ico" aria-label="Настройки" title="Настройки" data-testid="topbar-settings">
          <img src="/assets/meta/icon-settings.png" alt="" />
        </Link>
      </div>
    </header>
  );
}

// Иконки — сгенерённый мета-набор (assets-game/ready/meta → public/assets/meta);
// вкладки без подписей (игровой icon-only навбар), имя — в aria-label/title.
const NAV_TABS = [
  { to: '/map', ico: '/assets/meta/icon-map.png', label: 'Карта' },
  { to: '/collection', ico: '/assets/meta/icon-collection.png', label: 'Коллекция' },
  { to: '/catalog', ico: '/assets/meta/icon-catalog.png', label: 'Каталог' },
  { to: '/achievements', ico: '/assets/meta/icon-achievements.png', label: 'Достижения' },
] as const;

export function BottomNav() {
  return (
    <nav className="meta-nav" aria-label="Основная навигация" data-testid="meta-nav">
      {NAV_TABS.map((t) => (
        <NavLink key={t.to} to={t.to} aria-label={t.label} title={t.label} data-testid={`nav-${t.to.slice(1)}`}>
          <img className="nav-ico" src={t.ico} alt="" />
        </NavLink>
      ))}
    </nav>
  );
}

/** Саб-шапка второстепенного экрана: «назад» (по умолчанию на карту) + заголовок. */
export function SubHeader({ title, backTo = '/map', backLabel = 'Карта', right }: {
  title: string;
  backTo?: string;
  backLabel?: string;
  right?: ReactNode;
}) {
  return (
    <header className="meta-subbar">
      <Link to={backTo} className="back-link" data-testid="back-link">← {backLabel}</Link>
      <h1>{title}</h1>
      {right}
    </header>
  );
}
